module.exports = __webpack_public_path__ + "img/rimg1.7d41d95f.png";